"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/RichMessageWrapper/ContextMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('web/components/Tooltip');


















const ContextMenu = ({
  onClose, onReply, onCopy, onSaveAsTemplate, onTranslate, translating, onCopyMessageLink, onDelete, onDownload,
}) => (
  _react2.default.createElement(_Tooltip.TooltipContent, {
    onClick: onClose,
    className: "rich-message--menu--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}

    ,  onReply && (
      _react2.default.createElement('button', { type: "button", onClick: onReply, className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}, "reply"), "Reply"

      )
    )
    ,  onDownload && (
      _react2.default.createElement('button', { type: "button", onClick: onDownload, className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, "download"), "Download"

      )
    )
    ,  onCopy && (
      _react2.default.createElement('button', { type: "button", onClick: onCopy, className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        , _react2.default.createElement('img', { src: "assets/icons/video/copy-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} ), "Copy message"

      )
    )
    ,  onSaveAsTemplate && (
      _react2.default.createElement('button', { type: "button", onClick: onSaveAsTemplate, className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "bookmark_add"), "Save as template…"

      )
    )
    ,  onTranslate && (
      _react2.default.createElement('button', {
        type: "button",
        onClick: onTranslate,
        disabled: translating,
        'aria-busy': translating,
        className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}

        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "translate")
        , translating ? 'Translating…' : 'Translate'
      )
    )
    ,  onDelete && (
      _react2.default.createElement('button', {
        type: "button",
        onClick: onDelete,
        className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}

        , _react2.default.createElement('img', { src: "assets/icons/inbox/delete-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}} ), "Recall message"

      )
    )
    , _react2.default.createElement('button', {
      type: "button",
      onClick: onCopyMessageLink,
      className: "rich-message--menu--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}

      , _react2.default.createElement('img', { src: "assets/icons/inbox/link-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} ), "Copy link"

    )
  )
)

// Memoized: the row rebuilds this element on every hover, with the same
// (stable) handlers.
exports. default = _react2.default.memo(ContextMenu)
